
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import 'react';
import classNames from '../../../node_modules/classnames/index.js';
import { navItemContainer } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import { useReducedMotion } from '../../../node_modules/framer-motion/dist/es/utils/use-reduced-motion.mjs.js';
import { AnimatePresence } from '../../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs.js';
import { m } from '../../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs.js';

var labelVariants = {
  hidden: {
    display: "none",
    opacity: 0,
    x: -10
  },
  visible: function visible(_ref) {
    var isReducedMotion = _ref.isReducedMotion;
    return {
      display: "-webkit-box",
      opacity: 1,
      x: 0,
      transition: {
        duration: isReducedMotion ? 0 : 0.1,
        delay: isReducedMotion ? 0 : 0.2
      }
    };
  },
  exit: function exit(_ref2) {
    var isReducedMotion = _ref2.isReducedMotion;
    return {
      opacity: 0,
      x: -10,
      transition: {
        duration: isReducedMotion ? 0 : 0.1
      },
      transitionEnd: {
        display: "none"
      }
    };
  }
};
var NavItem = function NavItem(_ref3) {
  var isExpanded = _ref3.isExpanded,
    label = _ref3.label,
    _ref3$fontSize = _ref3.fontSize,
    fontSize = _ref3$fontSize === void 0 ? "md" : _ref3$fontSize,
    icon = _ref3.icon,
    _ref3$isActive = _ref3.isActive,
    isActive = _ref3$isActive === void 0 ? false : _ref3$isActive;
  var isReducedMotion = useReducedMotion();
  var containerClassNames = classNames({
    selected: isActive,
    "nav-item": true
  });
  return jsx("div", {
    css: function css(theme) {
      return navItemContainer(theme, fontSize);
    },
    className: containerClassNames
  }, jsx("div", {
    className: "icon-container"
  }, icon), jsx(AnimatePresence, null, isExpanded && jsx(m.div, {
    className: "title",
    initial: "hidden",
    animate: "visible",
    exit: "exit",
    variants: labelVariants,
    custom: {
      isReducedMotion: isReducedMotion
    }
  }, label)));
};

export { NavItem as default };
//# sourceMappingURL=NavItem.js.map
